import type { ConfigurableTablePage } from '../generated/graphql';
import type { AuthenticationConnections, Organization } from './organization';
import type { AuthAudienceTypes } from './organizationUser';
import type { TranslatedString } from './shared';

export enum NavigationStyles {
  FULL = 'FULL',
  SIMPLE = 'SIMPLE',
}

export type Role = {
  id?: string;
  translatedName?: TranslatedString;
  translatedDescription?: TranslatedString;
  permissions?: string[];
  accessiblePages?: string[];
  dashboards?: any[];
  publicRoleProfile?: PublicRoleProfile;
  organization?: Organization;
  roleProfile?: any;
  authAudience?: AuthAudienceTypes;
  navigationStyle?: NavigationStyles;
  individualPageConfiguration?: any;
  nonIndividualPageConfiguration?: any;
  goalPageConfiguration?: any;
  accountPageConfiguration?: any;
  accountGroupPageConfiguration?: any;
  householdPageConfiguration?: any;
  makeHouseholdDefaultView?: boolean;
  subAccountPageConfiguration?: any;
  homePageConfiguration?: any;
  individualTableStaticPageWidgetConfiguration?: any;
  nonIndividualTableStaticPageWidgetConfiguration?: any;
  householdTableStaticPageWidgetConfiguration?: any;
  accountGroupTableStaticPageWidgetConfiguration?: any;
  defaultAuthenticationConnection?: AuthenticationConnections;
  configurableTablePages?: ConfigurableTablePage[];
};

export type PublicRoleProfile = {
  id: string;
  organziation: Partial<Organization>;
  translatedDescription: TranslatedString;
  translatedName: TranslatedString;
};
